import { render } from "./VoucherIndex.vue?vue&type=template&id=a8890236&scoped=true"
import script from "./VoucherIndex.vue?vue&type=script&lang=js"
export * from "./VoucherIndex.vue?vue&type=script&lang=js"

import "./VoucherIndex.vue?vue&type=style&index=0&id=a8890236&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8890236"]])

export default __exports__